module.exports = __webpack_public_path__ + "7ed450bc6f770964183aca6855dd4b86.pdf";